let isRemoving = false;

async function syncThemeCart() {
  if (isRemoving) return;

  try {
    const cart = await fetch('/cart.js').then((r) =>
      r.json()
    );

    const cartVariantIds = cart.items.map(
      (item) => item.variant_id
    );

    //console.log('Cart:', cartVariantIds);

    for (const item of cart.items) {
      const config =
        window.variantDependencyMap?.[
          item.variant_id
        ];

      if (!config) continue;

      const allowedMainVariants =
        config.main_variants || [];

      // Item is a dependent product
      if (allowedMainVariants.length) {
        const hasValidMain =
          allowedMainVariants.some((id) =>
            cartVariantIds.includes(
              Number(id)
            )
          );

        if (!hasValidMain) {
          console.log(
            'Removing orphan dependent:',
            item.variant_id
          );

          isRemoving = true;

          await fetch(routes.cart_change_url, {
            ...fetchConfig(),
            body: JSON.stringify({
              id: item.key,
              quantity: 0,
            }),
          });

          publish(
            PUB_SUB_EVENTS.cartUpdate,
            {
              source: 'custom-cart-sync',
            }
          );

          isRemoving = false;

          return;
        }
      }
    }
  } catch (error) {
    isRemoving = false;
    console.error(error);
  }
}

function initThemeCartSync() {
  if (
    typeof subscribe !== 'undefined' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      () => {
        setTimeout(() => {
          syncThemeCart();
        }, 150);
      }
    );
  }

  syncThemeCart();
}

document.addEventListener(
  'DOMContentLoaded',
  initThemeCartSync
);